export default __webpack_public_path__ + "static/media/arrow_right.21193122.svg";